import { render } from "./Navigation.vue?vue&type=template&id=4046c332&bindings={\"menu\":\"setup\",\"scrollToHash\":\"setup\",\"setLocale\":\"setup\",\"locale\":\"setup\"}"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"
script.render = render

export default script